var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagerTagC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4555_68003)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4555_68003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "url(#paint0_linear_4555_68003)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4555_68003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 8.19531L11 6.52345L12.0005 4.19531L13 6.52345L12.0005 8.19531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3983 17.8048L17.6031 15.8359H6.43741L5.83984 17.8048H18.3983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08502 8.26449C7.90656 8.5597 7.1471 9.70484 7.33518 10.9047L8.00179 15.7019H11.9991V10.5429C11.9991 9.0168 10.5635 7.89547 9.08264 8.26687L9.08502 8.26449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6331 10.0358C4.77603 10.5453 4.44987 11.6214 4.8784 12.5213L6.40208 15.7043L7.3139 9.89772C6.78776 9.69297 6.17115 9.71678 5.63072 10.0358H5.6331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9154 8.26616C13.4346 7.89715 11.999 9.0161 11.999 10.5422L15.9963 15.7012L16.6629 10.904C16.851 9.70413 16.0915 8.55899 14.9131 8.26378L14.9154 8.26616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3678 10.0358C17.8297 9.71678 17.2131 9.69297 16.6846 9.89772L17.5964 15.7043L19.1201 12.5213C19.551 11.6238 19.2224 10.5453 18.3654 10.0358H18.3678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 10.543H6.41602V15.702H17.5984V10.543Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4555_68003",
    x: -4,
    y: -4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4555_68003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4555_68003",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4555_68003",
    x1: 20.6057,
    y1: -0.00000158267,
    x2: -1.59422,
    y2: 5.93738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6902FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F530EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4555_68003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4555_68003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6185,
    height: 15.6109,
    fill: "white",
    transform: "translate(4.69043 4.19531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerTagC);
export default __webpack_public_path__ + "static/media/manager_tag_c.e9a48e3aebfddf387b75afbea0b8c1fa.svg";
export { ForwardRef as ReactComponent };